import { gql } from '@apollo/client'

export default gql(`
    mutation updateCountry($id: ID!, $name: String!, $project: String ) {
        updateCountry(
            input: {
                name: $name
            },
            id: $id,
            project: $project
        ) {
            id
            name
            assetCount
        }
    }`
)
